function formatDuration(time: number): string {
  const hours = Math.floor(time / 60 / 60) % 60;
  const minutes = Math.floor(time / 60) % 60;
  const seconds = Math.floor(time) % 60;
  const hoursString = hours > 0 ? `${hours}:` : '';
  const minutesString = `${minutes > 9 ? '' : '0'}${minutes}:`;
  const secondsString = `${seconds > 9 ? '' : '0'}${seconds}`;
  return `${hoursString}${minutesString}${secondsString}`;
}

export default formatDuration;
